import { createTheme } from '@mui/material/styles';
import DraggableDialogPaper from './components/Common/DraggableDialogPaper';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5757b0',
      light: '#7777d0',
      dark: '#4545a0',
      contrastText: '#fff'
    },
    secondary: {
      main: '#f59e0b'
    },
    background: {
      default: '#f7f7ff',
      paper: '#ffffff'
    },
    text: {
      primary: '#222',
      secondary: '#666'
    }
  },
  shape: {
    borderRadius: 8
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    h4: {
      fontWeight: 600
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    },
    MuiDrawer: {
      defaultProps: {
        anchor: 'right'
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          // MUI forces `padding-top: 0` when DialogContent follows DialogTitle.
          // Use a CSS variable so dialogs can keep a shared default while
          // full-bleed viewers and compact dialogs can explicitly opt out.
          '.MuiDialogTitle-root + &': {
            paddingTop: 'var(--dialog-content-top-padding, 20px)'
          }
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        PaperComponent: DraggableDialogPaper
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          cursor: 'move',
          userSelect: 'none'
        }
      }
    }
  }
});

export default theme;
